export default "/images/cloud-lightning.svg?df5a952f89efd59413edbf0a125183fe";